<!-- <p>add-account-user works!</p> -->
<app-dialog-header headerIcon="person" headerText="Add User to Account" (onCloseClick)="onCancelClick()"></app-dialog-header>
<form [formGroup]="dialogForm">
	<div mat-dialog-content style="min-width: 300px; max-width: 500px;">
		<mat-form-field appearance="fill" *ngIf="appUsers">
			<mat-label>Users</mat-label>
			<mat-select formControlName="userID" >
				<mat-option *ngFor="let user of appUsers"
					[value]="user.UserID">{{user.Name}}</mat-option>
			</mat-select>
		</mat-form-field>
		<div class="md-form mb-1 matFormSlider">
			<div>
				<mat-label>Admin</mat-label>
				<mat-slide-toggle #switchEnabled formControlName="admin" color="primary"></mat-slide-toggle>
			</div>
		</div>
	</div>
	<div mat-dialog-actions>
		<button mat-button [mat-dialog-close]="dialogForm.value" 
			[disabled]="dialogForm.invalid || !dialogForm.dirty">Ok</button>
		<button mat-button (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
	</div>
</form>
